import { ElMessage } from 'element-plus'

const TEMPLATE_PREVIEW_INFO_KEY = 'templatePreviewInfo'

/**
 * 当使用模板预览时，转换访问的url
 * @param url 当前访问url
 * @returns 转换后的url
 */
export function transformUrlOnTemplatePreview(url: string | undefined) {
  if (!url) {
    return url
  }
  const _templatePreviewInfo = sessionStorage.getItem(TEMPLATE_PREVIEW_INFO_KEY)
  const templatePreviewInfo = _templatePreviewInfo
    ? JSON.parse(_templatePreviewInfo)
    : { isTemplatePreviewStatus: false, templateId: '' }
  // 只有处于模板预览状态时，才进行转换
  if (templatePreviewInfo.isTemplatePreviewStatus) {
    // 当前用户信息特殊处理
    if (['/api/v1/auth/current_user', '/api/v1/auth/currentUser'].includes(url)) {
      return `/api/v1/template-invoke/${templatePreviewInfo.templateId}/current_user`
    }
    const _url = url.replace(/projects\/\d+/, `template-invoke/${templatePreviewInfo.templateId}`)
    console.log('URL转换信息 ===>', url, _url)
    return _url
  }
  return url
}

export function getTemplatePreviewInfo() {
  const _templatePreviewInfo = sessionStorage.getItem(TEMPLATE_PREVIEW_INFO_KEY)
  const templatePreviewInfo = _templatePreviewInfo
    ? JSON.parse(_templatePreviewInfo)
    : { isTemplatePreviewStatus: false, templateId: '' }
  return templatePreviewInfo
}

export function showTemplatePreviewInfo(templateId: string) {
  sessionStorage.setItem(
    TEMPLATE_PREVIEW_INFO_KEY,
    JSON.stringify({
      isTemplatePreviewStatus: true,
      templateId: templateId
    })
  )
}

export function hideTemplatePreviewInfo() {
  sessionStorage.setItem(
    TEMPLATE_PREVIEW_INFO_KEY,
    JSON.stringify({
      isTemplatePreviewStatus: false,
      templateId: ''
    })
  )
}
/**
 * 是否是模版预览状态
 * @returns 模版预览状态
 */
export function isTemplatePreviewStatus() {
  const _templatePreviewInfo = getTemplatePreviewInfo()
  return _templatePreviewInfo.isTemplatePreviewStatus
}
/**
 * 模板预览状态时，增加提示
 * @param tip 提示信息，默认为：当前处于模板预览状态，无法进行表单提交等操作！
 * @returns 模版预览状态
 */
export function showTemplatePreviewTip(tip = '当前处于模板预览状态，无法进行数据访问类等操作！') {
  const _templatePreviewInfo = getTemplatePreviewInfo()
  if (_templatePreviewInfo.isTemplatePreviewStatus) {
    ElMessage.warning(tip)
  }
  return _templatePreviewInfo.isTemplatePreviewStatus
}
